import {useSuspenseQuery} from "@tanstack/react-query";
import {RegistryService} from "../../../services/registry-service";

export const useRegistriesOfMember = () => useSuspenseQuery({
    queryKey: ['registries', 'of-member'],
    queryFn: async () => await RegistryService.findAllWhereBreederIsMember(),
});